import classNames from 'classnames';
import styles from './styles.module.scss';

export interface IChipProps {
  text: string;
  className?: string;
}

const Chip = ({ text, className }: IChipProps) => (
  <div className={classNames(styles.chip, className)}>
    <div className={styles.text}>{text}</div>
  </div>
);

export default Chip;
